export default "\r\n<div class=\"admin-dashboard-container\">\r\n    <app-accounts></app-accounts>\r\n</div>\r\n";